/* ===========================================================
   EDGERUNNER ONESIES — Theme JS
   Click/change handlers are delegated on document so they keep
   working after sections re-render in the theme editor.
   =========================================================== */

(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---- COUNTDOWN (loops forever; length set in the Flash sale section) ---- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el._cdTimer) clearInterval(el._cdTimer);
      var duration = parseInt(el.getAttribute('data-duration'), 10) || 5400;
      var key = 'hc_countdown_' + duration;
      var restart = el.getAttribute('data-restart') === 'true';
      var start = NaN;
      if (!restart) { try { start = parseInt(localStorage.getItem(key), 10); } catch (e) {} }
      if (isNaN(start) || start > Date.now()) start = Date.now();

      var dEl = el.querySelector('[data-cd-days]');
      var hEl = el.querySelector('[data-cd-hours]');
      var mEl = el.querySelector('[data-cd-mins]');
      var sEl = el.querySelector('[data-cd-secs]');

      function tick() {
        var elapsed = Math.floor((Date.now() - start) / 1000);
        if (elapsed >= duration) {
          elapsed = elapsed % duration;
          start = Date.now() - elapsed * 1000;
        }
        if (!restart) { try { localStorage.setItem(key, start); } catch (e) {} }
        var r = duration - elapsed;
        if (dEl) dEl.textContent = pad(Math.floor(r / 86400));
        if (hEl) hEl.textContent = pad(Math.floor((dEl ? r % 86400 : r) / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((r % 3600) / 60));
        if (sEl) sEl.textContent = pad(r % 60);
      }
      tick();
      el._cdTimer = setInterval(tick, 1000);
    });
  }

  /* ---- GALLERY ---- */
  function galleryShow(gallery, index) {
    var images = gallery.querySelectorAll('[data-gallery-img]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!images.length) return;
    index = (index + images.length) % images.length;
    images.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    gallery._current = index;
  }

  /* ---- ACCORDION ---- */
  function toggleAccordion(btn) {
    var item = btn.closest('[data-accordion-item]');
    if (!item) return;
    var group = item.closest('[data-accordion-group]') || document;
    var isOpen = item.classList.contains('is-open');
    group.querySelectorAll('[data-accordion-item].is-open').forEach(function (open) {
      open.classList.remove('is-open');
      var p = open.querySelector('[data-accordion-panel]');
      if (p) p.style.maxHeight = '0';
      var b = open.querySelector('[data-accordion-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('is-open');
      var panel = item.querySelector('[data-accordion-panel]');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  /* ---- MODAL ---- */
  function openModal() {
    var overlay = document.querySelector('[data-modal-overlay]');
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    var overlay = document.querySelector('[data-modal-overlay]');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---- CLICK DELEGATION ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var thumb = t.closest('[data-gallery-thumb]');
    if (thumb) {
      var g = thumb.closest('[data-gallery]');
      galleryShow(g, Array.prototype.indexOf.call(g.querySelectorAll('[data-gallery-thumb]'), thumb));
      return;
    }
    var prev = t.closest('[data-gallery-prev]');
    if (prev) { var gp = prev.closest('[data-gallery]'); galleryShow(gp, (gp._current || 0) - 1); return; }
    var next = t.closest('[data-gallery-next]');
    if (next) { var gn = next.closest('[data-gallery]'); galleryShow(gn, (gn._current || 0) + 1); return; }

    var acc = t.closest('[data-accordion-toggle]');
    if (acc) { toggleAccordion(acc); return; }

    if (t.closest('[data-modal-open]')) { e.preventDefault(); openModal(); return; }
    if (t.closest('[data-modal-close]')) { closeModal(); return; }
    if (t.matches('[data-modal-overlay]')) { closeModal(); return; }

    if (t.closest('[data-sticky-btn]')) {
      var mainAdd = document.querySelector('[data-buy-add]');
      if (mainAdd && !mainAdd.disabled) {
        mainAdd.click();
      } else if (mainAdd) {
        mainAdd.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-modal-open]')) {
      e.preventDefault();
      openModal();
    }
  });

  /* ---- SWIPE ON GALLERY ---- */
  var touchStartX = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest('.gallery__main')) touchStartX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var main = e.target.closest('.gallery__main');
    if (!main) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) < 40) return;
    var g = main.closest('[data-gallery]');
    galleryShow(g, (g._current || 0) + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* ---- SIZE SELECTOR (tells bundle apps like Kaching about the change) ---- */
  document.addEventListener('change', function (e) {
    var pill = e.target.closest && e.target.closest('[data-size-pill], [data-option-pill]');
    if (!pill || !pill.checked) return;
    var wrap = pill.closest('[data-buy-buttons]');
    if (!wrap) return;
    var hidden = wrap.querySelector('[data-buy-id]');
    var btn = wrap.querySelector('[data-buy-add]');
    var label = wrap.querySelector('[data-buy-add-label]');
    var variantId = pill.value;
    var available = pill.getAttribute('data-available') === 'true';

    // Several options: match the checked pill of each row to a variant
    if (pill.hasAttribute('data-option-pill')) {
      var data = wrap.querySelector('[data-variants]');
      if (!data) return;
      var picked = [];
      wrap.querySelectorAll('[data-option-pill]:checked').forEach(function (p) {
        picked[+p.getAttribute('data-option-index')] = p.value;
      });
      var match = JSON.parse(data.textContent).filter(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      })[0];
      if (!match) return;
      variantId = String(match.id);
      available = match.available;
      if (match.media) {
        var g = document.querySelector('[data-gallery]');
        var imgs = g ? g.querySelectorAll('[data-gallery-img]') : [];
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].getAttribute('data-media-id') === String(match.media)) { galleryShow(g, i); break; }
        }
      }
    }

    if (hidden) {
      hidden.value = variantId;
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (btn) {
      btn.disabled = !available;
      if (label) {
        label.textContent = available
          ? (btn.getAttribute('data-label-add') || 'Add to Cart')
          : (btn.getAttribute('data-label-soldout') || 'Sold Out');
      }
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (err) {}
  });

  /* ---- CHARACTER PICKED IN ANY DROPDOWN (Kaching bundles): jump the gallery to that character's photo ---- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'SELECT') return;
    var data = document.querySelector('[data-option-media]');
    if (!data) return;
    var mediaId;
    try { mediaId = JSON.parse(data.textContent)[el.value]; } catch (err) { return; }
    if (!mediaId) return;
    var g = document.querySelector('[data-gallery]');
    var imgs = g ? g.querySelectorAll('[data-gallery-img]') : [];
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('data-media-id') === String(mediaId)) { galleryShow(g, i); break; }
    }
  });

  /* ---- ADD TO CART: native POST to /cart/add → /cart (Kaching-compatible) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    var label = form.querySelector('[data-buy-add-label]');
    if (label) label.textContent = 'Adding...';
  });

  /* ---- STICKY ATC (shows once the main button scrolls away) ---- */
  function checkSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainAdd = document.querySelector('[data-buy-add]');
    if (!bar || !mainAdd) return;
    bar.classList.toggle('is-visible', mainAdd.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', checkSticky, { passive: true });

  /* ---- INIT + THEME EDITOR SUPPORT ---- */
  function init(root) {
    initCountdowns(root || document);
    checkSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-accordion-item]');
    if (item && !item.classList.contains('is-open')) {
      var btn = item.querySelector('[data-accordion-toggle]');
      if (btn) toggleAccordion(btn);
    }
  });
})();
